import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import WarningModal from 'shared/lib/components/modals/warningModal';
import { useTranslation } from 'react-i18next';
import { ModalProps } from 'shared/lib/components/modals/modal';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { tablesApi } from 'entities/table/api/tablesApi';

export type DeleteTableModalControllerActions = {
  afterTableDelete?: (id: string) => void;
};

export default observer(function DeleteTableModalController({
  id,
  afterTableDelete,
  handleClose,
}: {
  id: string;
} & DeleteTableModalControllerActions & {
    handleClose: ModalProps['handleClose'];
  }) {
  const { mobxStore } = useContext(MobxContext);
  const { t } = useTranslation();

  return (
    <>
      <WarningModal
        mainText={t('warnings.delete.tableMain')}
        secondText={t('warnings.delete.tableSecond')}
        isOpen={true}
        onCancel={handleClose}
        onContinue={async () => {
          try {
            await tablesApi.delete(id);
            afterTableDelete && afterTableDelete(id);
          } catch (e) {
            mobxStore.notificationsStore.errorMessage = t(
              'notifications.errors.default'
            );
            console.error(e);
          }
          handleClose();
        }}
      ></WarningModal>
    </>
  );
});
